'use strict';

module.exports = Object.getOwnPropertySymbols;